import instance from 'utils/axios/instance.axios';
import { ADJUST_MEMBERS } from './_constant';

export const downloadPdfFile = (projectProposalId) =>
  instance.post(ADJUST_MEMBERS.DOWNLOAD_PDF_HUMAN_RESOURCE_FILE(projectProposalId),
    {
      responseType: 'blob',
    },
    {
      responseType: 'blob',
    });

export const downloadPdfTemplateFile = (projectProposalId) =>
  instance.post(ADJUST_MEMBERS.DOWNLOAD_PDF_TEMPLATE_HUMAN_RESOURCE_FILE(projectProposalId), {
    responseType: 'blob',
  });

export const downloadDocxFile = (projectProposalId) =>
  instance.post(ADJUST_MEMBERS.DOWNLOAD_DOCX_HUMAN_RESOURCE_FILE(projectProposalId), {
    responseType: 'blob',
  });

export const downloadDocxTemplateFile = (projectProposalId) =>
  instance.post(ADJUST_MEMBERS.DOWNLOAD_DOCX_TEMPLATE_HUMAN_RESOURCE_FILE(projectProposalId), {
    responseType: 'blob',
  });
